'use strict';

module.exports = {
    parseSetMethodArgs: function(args) {
        var attrs = {};
        var key = args[0];
        var options = {};
        if (_.isString(key)) {
            attrs[key] = args[1];
            options = args[2];
        } else if (_.isObject(key)) {
            attrs = _.isPlainObject(key) ? key : key.attributes;
            options = args[1];
        }
        return [attrs, options];
    },
};
